"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomCCNumberInput = function CustomCCNumberRenderer(_ref) {
  var storedValue = _ref.storedValue,
      isValid = _ref.isValid,
      complete = _ref.complete,
      fieldData = _ref.fieldData,
      eventHandler = _ref.eventHandler,
      isFocused = _ref.isFocused;
  var wrapperClasses = (0, _classnames["default"])({
    'text-input-control__wrapper': true,
    'text-input-control__wrapper--focused': isFocused,
    'text-input-control__wrapper--error': complete && !isValid,
    'text-input-control__wrapper--valid': complete && isValid
  });
  var errorId = "".concat(fieldData.id, "-error");
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: fieldData.id,
    className: "text-input-control__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-input-control__label-text"
  }, fieldData.label)), /*#__PURE__*/_react["default"].createElement("input", {
    id: fieldData.id,
    name: fieldData.fieldKey,
    className: "text-input-control__input",
    type: "text",
    pattern: "^\\d{4}\\s\\d{4}\\s\\d{4}\\s\\d*$",
    value: storedValue,
    onKeyUp: function onKeyUp(event) {
      return eventHandler.onKeyUp(event);
    },
    onKeyDown: function onKeyDown(event) {
      return eventHandler.onKeyDown(event);
    },
    onChange: function onChange(event) {
      return eventHandler.onChange(event);
    },
    onBlur: function onBlur(event) {
      return eventHandler.onBlur(event);
    },
    onFocus: function onFocus() {
      return eventHandler.onFocus();
    },
    autoComplete: fieldData.autocomplete,
    "aria-describedby": errorId,
    required: fieldData.validation.required
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: errorId,
    role: "alert",
    "aria-live": "assertive"
  }, !isValid && complete && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input-control__error"
  }, fieldData.validation.message)));
};

CustomCCNumberInput.propTypes = {
  storedValue: _propTypes["default"].string.isRequired,
  isValid: _propTypes["default"].bool.isRequired,
  complete: _propTypes["default"].bool.isRequired,
  isFocused: _propTypes["default"].bool.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func.isRequired,
    onFocus: _propTypes["default"].func.isRequired,
    onKeyUp: _propTypes["default"].func.isRequired,
    onKeyDown: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(RegExp)]),
      required: _propTypes["default"].bool
    }).isRequired,
    value: _propTypes["default"].string.isRequired,
    autocomplete: _propTypes["default"].string.isRequired
  }).isRequired
};
var _default = CustomCCNumberInput;
exports["default"] = _default;